import * as Yup from "yup";

export interface updatePasswordSchemaInterface {
  currentPin: string;
  confirmPassword: string;
  password: string;
}

const requiredFieldMessage = "Campo Obrigatório";

export const updatePasswordSchema: Yup.SchemaOf<updatePasswordSchemaInterface> =
  Yup.object().shape({
    currentPin: Yup.string().required(requiredFieldMessage)
      .matches(/^\d{4}$/, 'O PIN atual deve ter 4 dígitos'),
    confirmPassword: Yup.string()
      .required(requiredFieldMessage)
      .oneOf([Yup.ref('password')], 'Os PINs precisam ser iguais')
      .matches(/^\d{4}$/, 'O PIN deve ter 4 dígitos'),
    password: Yup.string().required(requiredFieldMessage)
      .matches(/^\d{4}$/, 'O PIN deve ter 4 dígitos'),
  });
